import {api} from "@/lib/api/wallet/api";
import {IBonus} from "@/lib/types/wallet/IBonus";
import {ILadderCampaign} from "@/lib/types/wallet/ILadderCampaign";

export const bonusApi = api.injectEndpoints({
    endpoints: build => ({
        getBonuses: build.query<IBonus[], void>({
            query: () => ({
                url: '/api/v1/bonuses',
                method: 'get',
            }),
            providesTags: ['GetBonuses'],
        }),
        getLadderCampaigns: build.query<ILadderCampaign[], void>({
            query: () => ({
                url: '/api/v1/bonuses/campaigns/me',
                method: 'get',
            }),
            providesTags: ['GetLadderCampaigns'],
        }),
        // MATERIALIZED bonus (real user_bonuses row, status=AVAILABLE) —
        // activates the existing row. Free Spins require a gameId (the player's
        // chosen game); CASH ignores it, so the body is omitted when absent.
        // AC-798: `currency` = the display currency at select time — FS packs
        // are issued to the provider in it (backend falls back to USD).
        selectBonus: build.mutation<void, {bonusId: string; gameId?: string; currency?: string}>({
            query: ({bonusId, gameId, currency}) => ({
                url: `/api/v1/bonuses/${bonusId}/select`,
                method: 'post',
                ...(gameId || currency ? {body: {...(gameId && {gameId}), ...(currency && {currency})}} : {}),
            }),
            invalidatesTags: ['GetBonuses', 'GetLadderCampaigns']
        }),
        // OFFERED_AVAILABLE bonus — backend materializes the row + burns
        // OR-group siblings inside the same transaction. Same gameId contract.
        selectOfferedBonus: build.mutation<void, {strategyId: string; bonusId: string; gameId?: string; currency?: string}>({
            query: ({strategyId, bonusId, gameId, currency}) => ({
                url: `/api/v1/bonuses/strategies/${strategyId}/bonuses/${bonusId}/select`,
                method: 'post',
                ...(gameId || currency ? {body: {...(gameId && {gameId}), ...(currency && {currency})}} : {}),
            }),
            invalidatesTags: ['GetBonuses', 'GetLadderCampaigns']
        }),
        unselectBonus: build.mutation<void, void>({
            query: () => ({
                url: `/api/v1/bonuses/unselect`,
                method: 'post'
            }),
            invalidatesTags: ['GetBonuses', 'GetLadderCampaigns']
        })
    })
})

export const {
    useGetBonusesQuery,
    useGetLadderCampaignsQuery,
    useSelectBonusMutation,
    useSelectOfferedBonusMutation,
    useUnselectBonusMutation,
} = bonusApi;
